import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import { MenuData, MenuTextData, ProductsData, UserData } from "../models/types";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { Link } from "react-router-dom";
import { searchProducts } from "../store/products/action";
import ProductCategories from "./ProductCategories";
import ProductSlider from './ProductSlider';
import { useIntl } from "react-intl";
import { Box, Typography } from "@material-ui/core";
import LocalHelmet from "./Helmet";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        bannerImage: {
            display: "block",
            width: "100%",
            maxHeight: "500px",
            objectFit: "cover",
        },
    }),
);

interface PropsFromState {
    loading: boolean;
    errors?: string;
    menu: MenuData[];
    text: MenuTextData;
    newProducts: ProductsData[];
    newProductsLoading: boolean;
    recentProducts: ProductsData[];
    recentProductsLoading: boolean;
    token: UserData["token"];
}

interface propsFromDispatch {
    searchProducts: (token: string, type: string) => any;
}

type AllProps = PropsFromState & propsFromDispatch;

const Landing: React.FC<AllProps> = ({
    loading,
    errors,
    menu,
    text,
    newProducts,
    newProductsLoading,
    recentProducts,
    recentProductsLoading,
    token,
    searchProducts
}) => {
    const intl = useIntl();
    const classes = useStyles();
    const siteUrl = window.location.origin;
    const homepageSchema = [
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "RetroStyle",
            "url": siteUrl,
            "logo": `${siteUrl}/images/logo.png`,
            "email": "retro@bpgroup.lv",
            "telephone": "+37129236283"
        },
        {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "RetroStyle",
            "url": siteUrl,
            "potentialAction": {
                "@type": "SearchAction",
                "target": `${siteUrl}/?search={search_term_string}`,
                "query-input": "required name=search_term_string"
            }
        }
    ];

    useEffect(() => {
        searchProducts(token, "new");
        searchProducts(token, "recent");
    }, [token, searchProducts]);

    return (
        <>
            <LocalHelmet titleId="title" descriptionId="description" structuredData={homepageSchema} />
            <Box px={3} pt={3}>
                <Typography component="h1" variant="h4">
                    RetroStyle
                </Typography>
            </Box>
            <Carousel infiniteLoop={true} interval={3000} autoPlay={true} centerMode={false} showThumbs={false} dynamicHeight={true}>
                <div>
                    <img className={classes.bannerImage} src="/images/Banner-1.png" alt={intl.formatMessage({ id: "image.bannerAlt" })} />
                </div>
                <div>
                    <img className={classes.bannerImage} src="/images/Banner-2.png" alt={intl.formatMessage({ id: "image.bannerAlt" })} />
                </div>
                <Link to="/product/category/Z2000278726">
                    <div>
                        <img className={classes.bannerImage} src="/images/Banner-3.png" alt={intl.formatMessage({ id: "image.bannerAlt" })} />
                    </div>
                </Link>
            </Carousel>
            <ProductSlider title="product.newProducts" dataLoading={newProductsLoading} data={newProducts} />
            <ProductCategories title="nav.catalog" />
            <ProductSlider title="product.recentProducts" dataLoading={recentProductsLoading} data={recentProducts} />
        </>
    );
};

const mapStateToProps = ({ menu, products, user }: ApplicationState) => ({
    loading: menu.loading,
    errors: menu.errors,
    menu: menu.menu,
    text: menu.text,
    newProducts: products.newProducts,
    newProductsLoading: products.newLoading,
    recentProducts: products.viewedProducts,
    recentProductsLoading: products.viewedLoading,
    token: user.user["token"]
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {
        searchProducts: (token: string, type: string) => {
            dispatch(searchProducts(token, type));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Landing);
